import { Link } from "react-router-dom";
import { Breadcrumb } from "antd"
import { useTenantUrl } from "../hooks/useTenantNavigation.js";

const BreadCrumb = (props) => {
    const { items, marginb } = props
    const buildUrl = useTenantUrl();

    const isMobile = new URLSearchParams(window.location.search).get("type") === "mobile"

    if (isMobile) {
        const lastItem = items?.[items.length - 1]
        if (!lastItem) return null
        return (
            <Breadcrumb
                items={[lastItem]}
                itemRender={(currentRoute) => <span>{currentRoute.title}</span>}
                style={{ marginBottom: marginb || "32px" }}
            />
        )
    }

    function itemRender(currentRoute, params, items, paths) {
        const isLast = currentRoute?.path === items[items.length - 1]?.path;
        let reqPath = paths.length > 0 ? paths.pop() : paths[0]

        return isLast ? (
          <span>{currentRoute.title}</span>
        ) : (
          <Link to={buildUrl(`/${reqPath}`)}>{currentRoute.title}</Link>
        );
      }

    return (
        <Breadcrumb items={items} itemRender={itemRender} style={{marginBottom: marginb || "32px"}} />
    )
}

export default BreadCrumb